// extracted by mini-css-extract-plugin
export default {"navContainer":"MyAccountNav_navContainer__zuzAE","nav":"MyAccountNav_nav__qCbsl","tab":"MyAccountNav_tab__669bo","active":"MyAccountNav_active__U5uSz"};